import { AppConfig } from '../../../app-config'
import getUserDetails from '../../../utils/actions/getUserDetails'
import { triggerSimpleAjax } from '../../../utils/http-helper'
import { SUBMIT_TYPE } from '../constants'
const API_URL = AppConfig.api_url

/**
 * This method handles the signup API req and basic success/error responses
 * @param {object} param
 *  -- param structure: {
 *  {string} signupType
 *  {object} reqObj
 *  {string} campaignItineraryId
 *  {function} successSubmitCallback - used to set submitting status in context
 *  {funciton} failureSubmitCallback - used to set errors state of signup context & submit status
 * }
 */
export const triggerSignup = ({
	signupType,
	reqObj = {},
	successSubmitCallback,
	failureSubmitCallback,
	dispatch,
}) => {
	let url = `${API_URL}user/homePage/signup`
	/**
	 * ! IMP_NOTE: we should pass signupType as SUBMIT_TYPE.SIGNUP_COSTING
	 * ! if we are triggering costing API after this signup
	 * Reason:
	 *  This `/signup/verifyotp` API will send the leadsource data to plato
	 *  Leads generated from this requests are considered as valid/legit
	 *
	 * Everything is same except the above reason
	 * That too will be solved if BE does a clean up on the old APIs
	 */
	if (signupType === SUBMIT_TYPE.SIGNUP_COSTING) {
		url = `${API_URL}user/signup/verifyotp`
	}
	return new Promise((resolve, reject) => {
		triggerSimpleAjax({
			url,
			method: 'POST',
			body: reqObj,
			onSuccess: response => {
				if (response.status === 'SUCCESS' || response.status === 'VERIFIED') {
					successSubmitCallback()

					getUserDetails({
						req_data: { prod_type: response.prod_type },
						authType: signupType,
						dispatch,
					})
						.then(userResponse => {
							resolve(userResponse)
						})
						.catch(reject)
				} else if (
					response.status === 'MOBILE_EXISTS' ||
					response.status === 'EMAIL_EXISTS'
				) {
					// setSignupStatus(response.status, response.message);
					failureSubmitCallback({
						mobileNumber: response?.message,
						message: response?.message,
						status: response?.status,
					})
					reject(response?.status)
				} else if (response.status === 'INVALID_EMAIL') {
					// setSignupStatus(response.status, response.message);
					failureSubmitCallback({
						email: response.message,
						status: response.status,
					})
					reject(response?.status)
				} else {
					failureSubmitCallback({
						mobileNumber: 'Unable to signup. Please try agian later.',
					})
					reject('Signup Failed')
				}
			},
			onFailure: error => {
				failureSubmitCallback({
					mobileNumber: 'Unable to signup. Please try agian later.',
				})
				reject(error)
			},
		})
	})
}
